import * as React from "react";
import { Loader } from "@grandvisionhq/common";
import { useIntl, useSelector, statusFailed, statusLoading, statusSuccess } from "@grandvisionhq/state";
import { useRxGlassesConfiguratorContext } from "../../../../context/context/RxGlassesConfiguratorContext.js";
import "../../../../state/state/actions.js";
import "../../../../state/add-to-cart/state/add-to-cart/selectors.js";
import "../../../../state/bundles/state/bundles/selectors.js";
import "../../../../state/bundles/state/bundles/reducer.js";
import { hasVisitedStepPrescription, getPrescription, getPrescriptionType } from "../../../../state/configurator/state/configurator/selectors.js";
import "../../../../state/configurator/state/configurator/reducer.js";
import "../../../../state/products/state/products/selectors.js";
import "../../../../state/products/state/products/reducer.js";
import { PrescriptionSummary } from "./PrescriptionSummary.js";
const PrescriptionSummaryContainer = (props) => {
  const { getLabel } = useIntl();
  const { id } = useRxGlassesConfiguratorContext();
  const hasVisitedStepPrescription$1 = useSelector(
    (s) => hasVisitedStepPrescription(s, { id })
  );
  const prescription = useSelector(getPrescription);
  const prescriptionType = useSelector(getPrescriptionType);
  if (!hasVisitedStepPrescription$1) {
    return null;
  }
  if (statusFailed(prescription)) {
    return /* @__PURE__ */ React.createElement("p", null, getLabel("products.glasses.prescription.loadingFailed"));
  }
  if (statusLoading(prescription)) {
    return /* @__PURE__ */ React.createElement(Loader, null);
  }
  if (!statusSuccess(prescription)) {
    return null;
  }
  const { right, left, parameters, uploadReferences } = prescription.result;
  return /* @__PURE__ */ React.createElement(
    PrescriptionSummary,
    {
      ...props,
      prescriptionType,
      parameters,
      right,
      left,
      uploadReferences
    }
  );
};
export {
  PrescriptionSummaryContainer
};
//# sourceMappingURL=PrescriptionSummaryContainer.js.map
